import React, { useCallback, useEffect } from "react";
import { useField } from "formik";
import { Form, Label, Select } from "semantic-ui-react";
import styles from "./style.module.css";

interface Props {
  placeholder?: string;
  name: string;
  options?: any;
  label?: string;
}

export default function PrioritySelectInput(props: Props) {
  const [field, meta, helpers] = useField(props.name);
  const setDefaultValue = useCallback(() => {
    helpers.setValue(props.options[0].value);
  }, [helpers, props.options]);

  useEffect(() => {
    setDefaultValue();
  }, []);
  return (
    <Form.Field error={meta.touched && !!meta.error}>
      <label>{props.label}</label>
      <Select
        clearable
        options={props.options}
        value={field.value ? field.value : props.options[0].value}
        onChange={(e, d) =>
          helpers.setValue(d.value ? d.value : props.options[0].value)
        }
        onBlur={() => helpers.setTouched(true)}
        placeholder={props.placeholder}
        className={
          field.value === "Low"
            ? `${styles.userStatus} ${styles.low}`
            : field.value === "Medium"
            ? `${styles.userStatus} ${styles.medium}`
            : `${styles.userStatus} ${styles.urgent}`
        }
      />
      {meta.touched && meta.error ? (
        <Label basic color="red">
          {meta.error}
        </Label>
      ) : null}
    </Form.Field>
  );
}
